module.exports = __webpack_public_path__ + "img/xhs-qrcode.f6fb16e.jpg";